import { PortalUser } from './portalUsers.firebase.models';

export class SetPortalUsersConnection {
	static readonly type = '[Portal Users] Set connection';
	constructor(public connect: boolean) {}
}

export class SetPortalUsers {
	static readonly type = '[Portal Users] Set portal users';
	constructor(public items: PortalUser[]) {}
}
